'use strict';

angular.module('substoreApp.controllers')
    .controller('catalogueController', CatalogueController);

function CatalogueController($scope, dialogData, sessionData, productDataCollector, productDataFinalizer, htmlTruster, webtrekk) {

    $scope.isCatalogueActive = true;

    $scope.breadcrumb.init('navigation_catalogue');

    $scope.data = {
        mainMessage: null,
        filteredProductList: [],
        filteredProductList2d: []
    };

    sessionData.deleteCurrentSubscription();

    var make2d = function (a, itemsPerPage) {
        if (!a) return a;
        var a2d = [], e;
        for (var i = 0, j = 0; i < a.length; i++, j++) {
            if (j % 2 === 0) a2d.push(e = []);

            e.push(a[i]);
            if(itemsPerPage % 2 === 1 && i % itemsPerPage === itemsPerPage - 1) {
                e.push(null);
                j++;
            }
        }
        return a2d;
    };

    function initDialogData() {
        $scope.data = dialogData;

        var productsCount = dialogData.productList.length;
        for (var p = 0; p < productsCount; p++) {
            productDataCollector.collect(dialogData.productList[p]);
            productDataFinalizer.checkAvailability(dialogData.productList[p]);
        }

        $scope.partnerFilter.setAvailableFilters($scope.data.availableFilters);
        $scope.productFilter.setAvailableFilters($scope.data.availableFilters);

        $scope.data.filteredProductList = dialogData.productList;
        htmlTruster.trust($scope.data.filteredProductList);

        if ($scope.data.filteredProductList.length > 0) {
            $scope.data.filteredProductList[0].isOpen = true;
        } else {
            $scope.data.mainMessage = "catalog_msg_empty";
        }
        if ($scope.data.viewFilterList && $scope.data.viewFilterList.length > 0) {
            $scope.pagination.itemsPerPage = $scope.data.viewFilterList[0];
        }

        $scope.data.filteredProductList2d = make2d($scope.data.filteredProductList, $scope.pagination.itemsPerPage);

        $scope.updateTeaser();
        $scope.applyFilters();
    }

    // configure filters

    var Filter = function Filter(filterType) {
        this.filterType = filterType;
        this.criterion = "";
        this.displayName = "";
        this.availableFilters = [];
    };

    Filter.prototype.setFilter = function (f) {
        if (f) {
            this.criterion = f.id;
            this.displayName = f.displayName;
        } else {
            this.criterion = "";
            this.displayName = "";
        }
    };

    Filter.prototype.setAvailableFilters = function (availableFilters) {
        var filters = [];
        if (availableFilters) {
            for (var i = 0; i < availableFilters.length; i++) {
                var f = availableFilters[i];
                if (f.type == this.filterType) {
                    filters.push(f);
                    if (f.initial) {
                        this.setFilter(f);
                    }
                }
            }
        }
        this.availableFilters = filters;
    };

    Filter.prototype.applyCriterion = function (list) {
        if (!this.criterion)
            return list;

        var filteredList = [];
        for (var i = 0; i < list.length; i++) {
            var product = list[i];
            if (product.belongsToFilters.indexOf(this.criterion) >= 0)
                filteredList.push(product);
        }

        return filteredList;
    };

    $scope.partnerFilter = new Filter("partner");
    $scope.productFilter = new Filter("product");

    $scope.applyFilters = function () {
        var list = $scope.partnerFilter.applyCriterion(
            $scope.productFilter.applyCriterion(
                $scope.data.productList));

        $scope.data.filteredProductList = list;
        $scope.data.filteredProductList2d = make2d(list, $scope.pagination.itemsPerPage);

        if ($scope.data.filteredProductList.length > 0) {
            $scope.data.filteredProductList[0].isOpen = true;
            $scope.data.mainMessage = null;
        } else
            $scope.data.mainMessage = "catalog_msg_empty";
    };

    $scope.resetFilters = function () {
        $scope.partnerFilter.setFilter(null);
        $scope.productFilter.setFilter(null);
        $scope.data.filteredProductList = $scope.data.productList;
        if ($scope.data.viewFilterList && $scope.data.viewFilterList.length > 0) {
            $scope.pagination.itemsPerPage = $scope.data.viewFilterList[0];
        }
        $scope.data.filteredProductList2d = make2d($scope.data.productList, $scope.pagination.itemsPerPage);
        $scope.data.mainMessage = null;
    };

    $scope.isFilterExpanded = true;

    // configure pagination

    $scope.pagination = {
        itemsPerPage: 4,
        currentPage: 1,
        forward: function () {
            this.currentPage = (this.isLastPage() ? this.currentPage : this.currentPage + 1);
        },
        backward: function () {
            this.currentPage = (this.currentPage > 1 ? this.currentPage - 1 : 1);
        },
        firstItem: function () {
            return (this.currentPage - 1) * this.itemsPerPage;
        },
        isFirstPage: function () {
            return (this.currentPage == 1);
        },
        isLastPage: function () {
            return ($scope.pagination.currentPage * $scope.pagination.itemsPerPage >= $scope.data.filteredProductList.length);
        },
        isMultiPage: function () {
            return ($scope.pagination.itemsPerPage < $scope.data.filteredProductList.length);
        },
        firstItemHalf: function() {
            if (this.itemsPerPage % 2 === 1) { // in case of uneven items per page
                return Math.ceil((this.firstItem() + (this.currentPage - 1))/2);
            }
            return this.firstItem()/2;
        },
        itemsPerPageHalf: function() {
            return Math.ceil(this.itemsPerPage/2);
        },
        totalCount: function totalCount(){
            return $scope.data.filteredProductList.length;
        },
        from: function from() {
            return ($scope.pagination.currentPage-1)*$scope.pagination.itemsPerPage+1;
        },
        to: function to() {
            var len = this.totalCount();
            return $scope.pagination.isLastPage() ? len : $scope.pagination.currentPage*$scope.pagination.itemsPerPage;
        }
    };

    // configure footnotes

    $scope.footnotes = [];

    var updateFootnotes = function () {
        $scope.footnotes = [];

        for (var i = $scope.pagination.firstItem(); i < $scope.data.filteredProductList.length && i < $scope.pagination.firstItem() + $scope.pagination.itemsPerPage; i++) {
            var p = $scope.data.filteredProductList[i];
            for (var j = 0; j < p.productDescription.footnotes.length; j++)
                $scope.footnotes.push(p.productDescription.footnotes[j]);
        }
    };

    $scope.$watch('data.filteredProductList', updateFootnotes);
    $scope.$watch('pagination.itemsPerPage', updateFootnotes);
    $scope.$watch('pagination.currentPage', updateFootnotes);

    initDialogData();

    webtrekk.track('catalogue', {});
}